import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=328e2d8b&scoped=true&lang=pug&"
import script from "./VSwitch.vue?vue&type=script&lang=js&"
export * from "./VSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=328e2d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e2d8b",
  null
  
)

export default component.exports